import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin-bottom: 1.5rem;
  justify-content: space-around;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 0.5rem 0;
  ${({ showEmptyStatuses }) =>
    !showEmptyStatuses &&
    css`
      justify-content: flex-start;
    `}
  
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,0.2);
    border-radius: 4px;
  }
  
  @media (max-width: 768px) {
    justify-content: flex-start;
    padding: 0.5rem 0.25rem;
  }
  
  @media (max-width: 360px) {
    padding: 0.5rem 0.1rem;
  }
`;

export const StatusItem = styled.div`
  display: flex;
  align-items: center;
  border-left: 3px solid ${props => props.color || '#ccc'};
  padding: 0 0.75rem;
  margin-right: 1.5rem;
  height: 38px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    margin-right: 1rem;
    padding: 0 0.5rem;
  }
  
  @media (max-width: 480px) {
    margin-right: 0.75rem;
    min-width: 110px;
  }
  
  @media (max-width: 360px) {
    margin-right: 0.5rem;
    min-width: 100px;
    padding: 0 0.4rem;
  }
`;

export const IconWrapper = styled.span`
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: ${props => props.color || 'inherit'};
  
  @media (max-width: 360px) {
    margin-right: 0.4rem;
    font-size: 0.9rem;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 70px;
`;

export const Amount = styled.span`
  font-weight: 600;
  font-size: 1rem;
  color: #333;
  line-height: 1.2;
  white-space: nowrap;
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
  }
`;

export const Label = styled.span`
  font-size: 0.75rem;
  color: #6c757d;
  line-height: 1;
  white-space: nowrap;
  
  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
  
  @media (max-width: 360px) {
    font-size: 0.65rem;
  }
  
  @media (max-width: 320px) {
    font-size: 0.6rem;
  }
  
  @media (max-width: 280px) {
    font-size: 0.55rem;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  width: 100%;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  width: 100%;
  color: #dc3545;
  text-align: center;
  padding: 0 1rem;
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 0 0.75rem;
  }
  
  @media (max-width: 360px) {
    font-size: 0.85rem;
    padding: 0 0.5rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.5rem;
`;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #6c757d;
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(0,0,0,0.05);
  }
  
  svg {
    margin-left: 0.25rem;
    font-size: 0.8rem;
  }
`;
